// extracted by mini-css-extract-plugin
export default {"list":"Workdays_list__7102H","button":"Workdays_button__8ocwQ","selected":"Workdays_selected__gMR-b","darkMode":"Workdays_darkMode__fTIZ-"};